(function(){
  function ready0(fn){document.readyState!=='loading'?fn():document.addEventListener('DOMContentLoaded',fn)}
  ready0(function(){
    var card=document.querySelector('.ory-description__card');
    if(card&&!card.querySelector('.ory-description__texture')){
      var src=document.querySelector('.ory-gallery__image');
      if(src){var wrap=document.createElement('div');wrap.className='ory-description__texture';var im=document.createElement('img');im.src=src.getAttribute('src');if(src.getAttribute('srcset')){im.srcset=src.getAttribute('srcset');im.sizes='(max-width: 749px) 100vw, 50vw';}im.alt=src.alt||'';im.loading='lazy';wrap.appendChild(im);card.appendChild(wrap);}
    }
  });
  var reduce=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
  if(reduce||!('IntersectionObserver' in window))return;
  document.documentElement.classList.add('ory-anim');
  function ready(fn){document.readyState!=='loading'?fn():document.addEventListener('DOMContentLoaded',fn)}
  ready(function(){
    var sections=document.querySelectorAll('main .shopify-section');
    sections.forEach(function(sec,i){
      if(i===0)return;
      var first=sec.firstElementChild;
      if(first&&!sec.querySelector('[data-ory-reveal]'))first.classList.add('ory-auto-reveal');
    });
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target)}})
    },{rootMargin:'0px 0px -8% 0px',threshold:0.08});
    document.querySelectorAll('[data-ory-reveal],.ory-auto-reveal').forEach(function(el){
      var r=el.getBoundingClientRect();
      if(r.top<window.innerHeight&&r.bottom>0){el.classList.add('is-in');}else{io.observe(el)}
    });
    setTimeout(function(){document.querySelectorAll('[data-ory-reveal]:not(.is-in),.ory-auto-reveal:not(.is-in)').forEach(function(el){if(el.getBoundingClientRect().top<window.innerHeight)el.classList.add('is-in')})},2500);
  });
})();
